



































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import AbpBase from '../../../lib/abpbase'

// 表单数据模型
interface FormData {
    id: number;
    shippingMark: string; // 唛头
    trackingNumber: string; // 运单号
    remark: string; // 备注
    planNumbers: string[]; // 计划批次号（仅用于传递，不编辑）
}

@Component({ name: 'BackPackingPlanExtraForm' })
export default class PackingPlanExtraForm extends AbpBase {
    @Prop({ type: Boolean, default: false }) value!: boolean;
    // 表单数据
    formData: FormData = {
        id: 0,
        shippingMark: '',
        trackingNumber: '',
        remark: '',
        planNumbers: []
    };
    // 表单校验规则
    formRules = {
        shippingMark: [
            { required: true, message: '请输入唛头', trigger: 'blur' }
        ],
        trackingNumber: [
            {  message: '请输入运单号', trigger: 'blur' }
        ]
    };

    // 弹窗显隐变化
    visibleChange(val: boolean) {
        if (val) {
            this.initForm();
        } else {
            this.resetForm();
        }
    }

    // 初始化表单
    async initForm() {
        // 获取Vuex中的装箱模型
        const packingModel = this.$store.state.backPackingBatch.packingModel;
        if (packingModel && packingModel.id) {
            // 回显扩展信息
            this.formData.id = packingModel.id;
            this.formData.shippingMark = packingModel.shippingMark || '';
            this.formData.trackingNumber = packingModel.trackingNumber || '';
            this.formData.remark = packingModel.remark || '';
            //// 提取计划批次号（仅用于传递，不编辑）
            //if (packingModel.InStockList && packingModel.InStockList.length) {
            //    this.formData.planNumbers = packingModel.InStockList
            //        .map((item: any) => item.PlanNumber || '')
            //        .filter(Boolean);
            //}
        } else {
            // 重置表单
            this.resetForm();
        }
    }

    // 重置表单
    resetForm() {
        this.formData = {
            id: 0,
            shippingMark: '',
            trackingNumber: '',
            remark: '',
            planNumbers: []
        };
        (this.$refs.packingPlanExtraForm as any).resetValidation();
    }

    // 提交表单
    @Emit('save-success')
    async handleSubmit() {
        // 表单校验
        const formRef = this.$refs.packingPlanExtraForm as any;
        await formRef.validate();

        // 构造提交参数（对应ModifyPackPlan接口）
        const submitData = {
            Id: this.formData.id,
            PlanNumbers: this.formData.planNumbers, // 传递原有计划批次号，避免后端覆盖
            ShippingMark: this.formData.shippingMark,
            TrackingNumber: this.formData.trackingNumber,
            Remark: this.formData.remark
        };

        // 调用编辑扩展信息接口
        await this.$store.dispatch({
            type: 'backPackingBatch/modifyPackPlan',
            data: submitData
        });

        this.$Message.success('扩展信息保存成功！');
        this.$emit('save-success');
        this.handleCancel();
    }

    // 取消弹窗
    handleCancel() {
        this.$emit('input', false);
        this.resetForm();
    }
}
